<script>
import apiConnector from '@/epersonam/apiConnector';
import spinner from '../spinner';
import richTextEditor from '../richTextEditor';
import vSelect2 from '../vSelect2';
import vtextarea from '../vtextarea/vtextarea.vue';
import { TextDecoded } from '§/components/textArea/buttons/textDecoded';
import { RequirementsButton } from '§/components/textArea/buttons/requirementsButton';
import { ImagesButton } from '§/components/textArea/buttons/imagesButton';
import { Route } from '../../route';

export default {
  name: 'reportTemplates',
  components: {
    spinner,
    richTextEditor,
    vSelect2,
    vtextarea,
  },

  data() {
    return {
      customButton: null,
      baseUrl: '',
      isLoading: false,
      reportSections: [],
      currReportTemplateOriginal: null,
      currReportTemplate: null,
      report_templates: [],
      report_type: 'cartella',
      MAX_IMAGE_SIZE: 3000000,
      toolbar: 'paste',
      paste_data_images: true,
      acceptableModels: [
        {
          model: 'user',
          attributes: ['firstname', 'lastname'],
        },
      ],
    };
  },
  props: ['currentBuId', 'buTree', 'workerStruttura', 'workerUser'],
  computed: {
    customButtonNames() {
      this.setupAdv();
      this.customButtons();
      return this.customButton
        .filter((button) => button.condition)
        .map((button) => `${button.name}`)
        .join(' | ');
    },
    isValid() {
      return this.currReportTemplate && this.currReportTemplate.description && this.currReportTemplate.description != '';
    },
    allSelected() {
      return this.currReportTemplate && !Object.values(this.currReportTemplate.sections).reduce((allSel, value) => allSel && !value, true);
    },
  },
  template: '#report-templates-vue',
  mounted() {
    const dataOptions = $('#report-templates-cont').data();
    this.report_type = dataOptions.reportType;
    this.reportSections = dataOptions.reportSections;
    this.baseUrl = `/${window.locale}/report_templates`;
    this.report_templates = dataOptions.reportTemplates.map((t) => this.parseReportTemplate(t));
  },
  methods: {
    setupAdv() {
      window.advConfig = {
        ...window.advConfig,
        user: {
          super: window.config?.user?.super,
        },
        businessUnit: {
          id: window.config.business_unit.id,
        },
      };
      // TODO add parameter to buttons on acare_fe
    },
    setup(editor) {
      this.customButton.forEach((button) => {
        if (button.type !== 'button') {
          editor.ui.registry.addMenuButton(button.name, button.getButton(editor));
        } else {
          editor.ui.registry.addButton(button.name, button.getButton(editor));
        }
      });
    },
    customButtons() {
      const labels = {
        insert_text: window.i18nJS.insert_text,
        go_to_decodes: window.i18nJS.go_to_decodes,
      };
      const decodesValuesUrl = `${window.config.ePersonamService.ePersonamHost}${Route.DECODES_CONFIG_GET_VALUES}`;
      const requirementsUrl = `${window.config.ePersonamService.ePersonamHost}${Route.REPORT_TEMPLATE}/requirements.json`;
      this.customButton = [
        new ImagesButton(true),
        new TextDecoded(labels, decodesValuesUrl),
        new RequirementsButton(true, requirementsUrl),
      ];

      return {
        imagesButton: new ImagesButton(true),
        textDecoded: new TextDecoded(labels, decodesValuesUrl),
        requirementsButton: new RequirementsButton(true, requirementsUrl),
      };
    },
    openDecodes(type) {
      $('.modal').modal('hide');
      Loader.show();
      apiConnector()
        .get(`${Route.DECODES_CONFIG}.js?business_unit_id=${window.config.business_unit.id}&cod=report_templates_groups&key=${type}`)
        .then((res) => {
          eval(res.data);
        });
    },
    goBack() {
      window.history.back();
    },
    parseReportTemplate(report_template) {
      report_template.business_unit_id = report_template.business_unit_id || this.currentBuId;
      if (!report_template.sections) {
        report_template.sections = {};
        for (let i = 0; i < this.reportSections.length; i++) {
          const reportSection = this.reportSections[i];
          report_template.sections[reportSection.id] = null;
        }
      }
      return report_template;
    },
    checkboxChange(reportSectionId) {
      const sectionValue = this.currReportTemplate.sections[reportSectionId];
      const section = this.reportSections.find((s) => s.id == reportSectionId);
      const defaultValue = section.options ? section.options[0][0] : section.value;
      let newVal = sectionValue == defaultValue ? null : defaultValue;
      this.$set(this.currReportTemplate.sections, reportSectionId, newVal);
    },
    openModal(evt, title, reportTemplate) {
      this.currReportTemplateOriginal = reportTemplate || this.parseReportTemplate({});
      this.currReportTemplate = { ...this.currReportTemplateOriginal }; // clone
      this.currReportTemplate.report_type = this.report_type;

      if (this.currReportTemplate.header === null) {
        this.currReportTemplate.header = '';
      }

      if (this.currReportTemplate.body === null) {
        this.currReportTemplate.body = '';
      }

      if (this.currReportTemplate.footer === null) {
        this.currReportTemplate.footer = '';
      }

      evt.preventDefault();
      $('#report-template-label').text(title);
      $('#edit-report-template-form').modal('show');
    },
    saveModal(saveError) {
      this.isLoading = true;
      // this.currReportTemplate.requirements = this.getTemplateRequirements();
      apiConnector()
        .post(`${this.baseUrl}`, {
          report_template: this.currReportTemplate,
        })
        .then((res) => {
          this.isLoading = false;
          $('#edit-report-template-form').modal('hide');
          if (res.data.success) {
            if (this.currReportTemplate.id || this.currReportTemplate.model_kind) {
              this.report_templates = this.report_templates.map((r) => {
                return r == this.currReportTemplateOriginal ? this.parseReportTemplate(res.data.report_template) : r;
              });
            } else {
              this.report_templates.push(res.data.report_template);
            }
          } else {
            alert(saveError);
          }
        });
    },
    destroyTemplate(evt, title, reportTemplate, error) {
      evt.preventDefault();
      evt.stopPropagation();
      if (confirm(title)) {
        this.isLoading = true;
        apiConnector()
          .delete(`${this.baseUrl}/${reportTemplate.id}`)
          .then((res) => {
            this.isLoading = false;
            if (res.data.success) {
              this.report_templates = this.report_templates
                .map((r) => {
                  if (r === reportTemplate) {
                    return r.model_kind
                      ? this.parseReportTemplate({
                          permissions: r.permissions,
                          description: r.description,
                          model_kind: r.model_kind,
                        })
                      : null;
                  }
                  return r;
                })
                .filter((r) => r);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            console.log(err);
            alert(error);
          });
      }
    },
    // Selection
    toggleAll() {
      let sectionVals = {};
      for (let [reportSectionId, v] of Object.entries(this.currReportTemplate.sections)) {
        const section = this.reportSections.find((s) => s.id == reportSectionId);
        const defaultValue = section.options ? section.options[0][0] : section.value;
        sectionVals[reportSectionId] = this.allSelected ? null : defaultValue;
      }
      this.currReportTemplate.sections = sectionVals;
    },
    async printReport(report) {
      try {
        const sendToModal = this.report_type == 'struttura' ? this.printStruttura(report) : await this.printUser(report);
        if (sendToModal) {
          eventBus.$emit('openModalTemplateRequirements', sendToModal);
        }
      } catch (exception) {
        console.error('Impossibile stampare qualcosa non ha funzionato', exception);
      }
    },
    printStruttura(report) {
      return {
        data: report,
        bu_id: this.currentBuId,
        url: this.workerStruttura,
      };
    },
    async printUser(report) {
      const params = {
        report_template: {
          id: report,
          business_unit_id: this.currentBuId,
        },
      };
      try {
        const response = await apiConnector().post(`${this.baseUrl}/how_print_options`, params);
        return {
          data: report,
          bu_id: this.currentBuId,
          params: { print_with_gpds_id: true, guest_period_data_set_id: this.gpds },
          url: this.workerUser,
          how_print: response.data,
        };
      } catch (exception) {
        console.error('Impossibile stampare qualcosa non ha funzionato', exception);
        return null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.js-tooltip {
  display: inherit;
}

.active-area {
  cursor: pointer;
}

.button-table2 {
  text-align: left;
}

td.button-table2,
th.button-table2 {
  width: 150px !important;
}

.report-sections {
  margin-bottom: 20px;

  .sections-head {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }

  .sections-cont {
    display: flex;
    flex-wrap: wrap;
    height: 510px;
    flex-direction: column;
  }

  .report-section {
    display: flex;
    align-items: baseline;
  }

  label {
    display: inline;
  }

  select {
    width: 120px;
    margin: 0;
    padding: 0;
    margin-left: auto;
    margin-right: 25px;
  }

  input[type='checkbox'] {
    margin-right: 5px;
  }
}

textarea {
  width: 100%;
  box-sizing: border-box;
}
</style>
